import {
  INIT_KIT,
  RESET_ATTACHMENT,
  FOUND_KIT,
  NOT_FOUND_KIT,
  ATTACHING_KIT,
  ATTACH_SUCCESS,
  ATTACH_ERROR,
} from "../actions/kit";

const kitInitialState = {
  kitNumber: null,
  status: null,
  kitComponents: null,
  attached: false,
  registrationStatus: null,
};

const kitReducer = (state = kitInitialState, action) => {
  switch (action.type) {
    case "RESET_STORE":
    case "RESET_KIT":
    case "LOGOUT_STORE":
      return {
        ...kitInitialState,
      };
    case INIT_KIT:
      return {
        ...state,
        status: "FETCHING",
        kitNumber: action.payload.kitNumber,
      };
    case FOUND_KIT:
      return {
        ...state,
        status: "FOUND",
        kitComponents: action.payload,
      };
    case NOT_FOUND_KIT:
      return {
        ...state,
        status: "NOT FOUND",
      };
    case RESET_ATTACHMENT:
      return {
        ...state,
        registrationStatus: null,
      };
    case ATTACHING_KIT:
      return {
        ...state,
        registrationStatus: "ATTACHING",
      };
    case ATTACH_SUCCESS:
      return {
        ...state,
        registrationStatus: "SUCCESS",
      };
    case ATTACH_ERROR:
      return {
        ...state,
        registrationStatus: "ERROR",
      };
    default:
      return state;
  }
};

export default kitReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/kit.js